export default [
//在职员工
{
	path: '/IncumbentEmployeeDetail',
	name: 'IncumbentEmployeeDetail',
	component: (resolve) => require(['@/pages/StaffPage/detail_I.vue'], resolve),
}, 
//在职员工添加
{
	path: '/IncumbentEmployeeAdd',
	name: 'IncumbentEmployeeAdd',
	component: (resolve) => require(['@/pages/StaffPage/add_I.vue'], resolve)
}, 
//离职员工
{
	path: '/ResignationEmployeeDetail',
	name: 'ResignationEmployeeDetail',
	component: (resolve) => require(['@/pages/StaffPage/detail_R.vue'], resolve)
}, 

{
	path: '/companyCertificateDetail',
	name: 'companyCertificateDetail',
	component: (resolve) => require(['@/pages/certificateManger/company/detail.vue'], resolve)
}, {
	path: '/personCertificateDetail',
	name: 'personCertificateDetail',
	component: (resolve) => require(['@/pages/certificateManger/person/detail.vue'], resolve)
}, {
	path: '/digitalCertificateDetail',
	name: 'digitalCertificateDetail',
	component: (resolve) => require(['@/pages/certificateManger/digital/detail.vue'], resolve)
}, 
{
	path: '/companyCertificateAdd',
	name: 'companyCertificateAdd',
	component: (resolve) => require(['@/pages/certificateManger/company/add.vue'], resolve)
}, {
	path: '/personCertificateAdd',
	name: 'personCertificateAdd',
	component: (resolve) => require(['@/pages/certificateManger/person/add.vue'], resolve)
}, {
	path: '/digitalCertificateAdd',
	name: 'digitalCertificateAdd',
	component: (resolve) => require(['@/pages/certificateManger/digital/add.vue'], resolve)
}, 
//中标编辑
{
	path: '/WinningBidProjectDetail',
	name: 'WinningBidProjectDetail',
	component: (resolve) => require(['@/pages/projectPage/bidManagement/detail_W.vue'], resolve)
}, 
//投标编辑
{
	path: '/TenderProjectDetail',
	name: 'TenderProjectDetail',
	component: (resolve) => require(['@/pages/projectPage/bidManagement/detail_T.vue'], resolve)
}, 
//中标编辑
{
	path: '/WinningBidProjectAdd',
	name: 'WinningBidProjectAdd',
	component: (resolve) => require(['@/pages/projectPage/bidManagement/add_W.vue'], resolve)
}, 
//投标编辑
{
	path: '/TenderProjectAdd',
	name: 'TenderProjectAdd',
	component: (resolve) => require(['@/pages/projectPage/bidManagement/add_T.vue'], resolve)
}, 
// 收款合同
{
	path: '/ReceiptContractDetail',
	name: 'ReceiptContractDetail',
	component: (resolve) => require(['@/pages/projectPage/contractManagement/detail_R.vue'], resolve)
}, 
// 付款合同
{
	path: '/PaymentContractDetail',
	name: 'PaymentContractDetail',
	component: (resolve) => require(['@/pages/projectPage/contractManagement/detail_P.vue'], resolve)
}, 
// 收款合同
{
	path: '/ReceiptContractAdd',
	name: 'ReceiptContractAdd',
	component: (resolve) => require(['@/pages/projectPage/contractManagement/add_R.vue'], resolve)
}, 
// 付款合同
{
	path: '/PaymentContractAdd',
	name: 'PaymentContractAdd',
	component: (resolve) => require(['@/pages/projectPage/contractManagement/add_P.vue'], resolve)
}, 
//在建编辑
{
	path: '/UnderProjectDetail',
	name: 'UnderProjectDetail',
	component: (resolve) => require(['@/pages/projectPage/projectManagement/detail_U.vue'], resolve)
}, 
//竣工编辑
{
	path: '/CompletionProjectDetail',
	name: 'CompletionProjectDetail',
	component: (resolve) => require(['@/pages/projectPage/projectManagement/detail_C.vue'], resolve)
}, 
//在建编辑
{
	path: '/UnderProjectAdd',
	name: 'UnderProjectAdd',
	component: (resolve) => require(['@/pages/projectPage/projectManagement/add_U.vue'], resolve)
}, 
//竣工编辑
{
	path: '/CompletionProjectAdd',
	name: 'CompletionProjectAdd',
	component: (resolve) => require(['@/pages/projectPage/projectManagement/add_C.vue'], resolve)
}, 
{
	path: '/SystemWareSet',
	name: 'SystemWareSet',
	component: (resolve) => require(['@/pages/systemSetup/warn.vue'], resolve)
}, {
	path: '/BaseDataSet',
	name: 'BaseDataSet',
	component: (resolve) => require(['@/pages/systemSetup/essential.vue'], resolve)
}, {
	path: '/SensitiveWordSet',
	name: 'SensitiveWordSet',
	component: (resolve) => require(['@/pages/systemSetup/sensitivity.vue'], resolve)
}]



// WEBPACK FOOTER //
// ./src/router/map/ls.js